import { SafePromise } from '@benzinga/safe-await';
import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { IngressProduct } from './ingress';
import { ProductsEnvironment } from './environment';

export class ProductRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(ProductsEnvironment).url, session, {
      authorizationSession: true,
      'x-device-key': true,
    });
  }

  public getProduct = (productName: string): SafePromise<IngressProduct> => {
    const url = this.URL(`api/v1/products/${productName}/`);
    return this.get(url);
  };
}
